import { EventEmitter } from 'events'

/**
 * 事件名称
 */
export const EVENT_EMIT_NAME = {
  MEMBER_RECEIVE_MODAL_TOGGLE: 'MEMBER_RECEIVE_MODAL_SHOW', // 会员领取弹框打开、关闭
}

export default new EventEmitter()
